module.exports = __webpack_public_path__ + "img/p-sec01-img01.81ee776c.png";